var SharedServicesModule = (function () {
    function SharedServicesModule() {
    }
    return SharedServicesModule;
}());
export { SharedServicesModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/shared/shared-services.module.ts.pre-build-optimizer.js